export function randomImg(){
  let randomImgs = document.querySelectorAll('.js-randomImg');
  let randomImgsNum = randomImgs.length;

  if(randomImgsNum === 0) {
    return;
  }

  randomImgs = [].slice.call(randomImgs)
  
  function getRandomInt(max) {
    return Math.floor(Math.random() * max);
  }

  randomImgs.forEach((item)=>{
    item.style.display = "none";
  })

  randomImgs[getRandomInt(randomImgsNum)].style.display = "block";
}